import { AvisoSesionTerminada, BotonIngresar, BotonSalir, CompletarIngreso, useSesion } from "@/features/sesion";
import { t } from "@/shared/i18n";
import { PlantillaAcceso } from "@/templates";
import { useTitulo } from "./comun";

const s = t.sesion;

/** Sin sesión: un botón lleva a la página de ingreso de Cognito (sin redirección automática). */
export function Ingresar({ demo }: { readonly demo: boolean }) {
  useTitulo(s.tituloIngreso);
  return (
    <PlantillaAcceso titulo={s.tituloIngreso} subtitulo={s.textoIngreso} demo={demo}>
      <AvisoSesionTerminada />
      <BotonIngresar />
    </PlantillaAcceso>
  );
}

/** `/ingreso`: vuelta desde Cognito con el código. */
export function Retorno({ demo }: { readonly demo: boolean }) {
  useTitulo(s.tituloIngreso);
  return (
    <PlantillaAcceso titulo={s.tituloIngreso} demo={demo}>
      <CompletarIngreso accionError={<BotonIngresar />} />
    </PlantillaAcceso>
  );
}

/** Con sesión pero sin el grupo `portal-admin` (o sin correo @bvlchile.com). La API también lo rechaza. */
export function SinPermiso({ demo }: { readonly demo: boolean }) {
  const { empleado } = useSesion();
  useTitulo(s.sinPermisoTitulo);
  return (
    <PlantillaAcceso titulo={s.sinPermisoTitulo} subtitulo={s.sinPermisoTexto(empleado?.correo ?? "")} demo={demo}>
      <BotonSalir variante="principal" />
    </PlantillaAcceso>
  );
}
